import "./Aboutme.css"
export default function Aboutme() {
  return <section className="about-me" id="aboutme"><h3 className="aboutme-head">ABOUT ME</h3>
    <p className="aboutme-para">I'm a full stack developer with  experience in React Js, Node Js(APIs),Docker and PostgreSQL. I'm a quick learner, have good attention  to detail and strong UI/UX knowledge.</p>
  </section>
}